import React from "react";
import { Link } from "react-router-dom";
import { FiHome } from "react-icons/fi";

export default function NotFound() {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <h1 className="display-1 fw-bold text-danger">404</h1>
      <h4 className="mb-3">Oops! Page Not Found</h4>
      <p className="text-muted mb-4">
        The page you are looking for doesn’t exist or has been moved.
      </p>
      <Link to="/" className="btn btn-primary d-flex align-items-center gap-2">
        <FiHome size={18} /> Back to Home
      </Link>
    </div>
  );
}